import useStatsGroupedByRating from './useStatsGroupedByRating'

export default { useStatsGroupedByRating }